<template>
  <div class="triangle-header">
    <slot></slot>
  </div>
</template>

<script>
  import Trianglify from 'trianglify'
  export default {
    props: {
      seed: {
        type: Number,
        default: null
      }
    },
    mounted () {
      const pattern = Trianglify({
        seed: this.seed,
        width: 1000,
        height: 200
      })
      this.$el.appendChild(pattern.canvas())
    }
  }
</script>

<style lang="stylus">
  @import "../variables"

  .triangle-header {
    position: relative;
  }

  .triangle-header canvas {
    width: 100%;
    display: block;
    @media $display-breakpoints.sm-and-down {
      height: 175px;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/TriangleHeader.vue